import React from 'react'
import FormsChart from './FormsChart'
import InstitutionsChart from './InstitutionsChart'
import useStatData from '../../../../hooks/useStatData'
import UsersChart from './usersChart'
import AnswersChart from './AnswersChart'
import ReceivedRequestsChart from './ReceivedRequestsChart'
import PropTypes from 'prop-types'
import AttendedRequestsChart from './AttendedRequestsChart'

const ChartDisplay = ({ selectedIndicator, accessRules }) => {
  const { results } = useStatData(selectedIndicator)

  const chartTypes = {
    forms: FormsChart,
    institutions: InstitutionsChart,
    users: UsersChart,
    answers: AnswersChart,
    receivedRequests: ReceivedRequestsChart,
    attendedRequests: AttendedRequestsChart
  }
  const ComponentChart = chartTypes[selectedIndicator]

  if (!accessRules.includes(selectedIndicator) || !ComponentChart) {
    return <div>Gráfico no habilitado</div>
  }

  return <ComponentChart results={results} />
}

ChartDisplay.propTypes = {
  selectedIndicator: PropTypes.string.isRequired,
  accessRules: PropTypes.array.isRequired
}

export default ChartDisplay
